import { render } from "./saveway.vue?vue&type=template&id=dd57bf94&scoped=true&ts=true"
import script from "./saveway.vue?vue&type=script&lang=ts"
export * from "./saveway.vue?vue&type=script&lang=ts"

import "./saveway.vue?vue&type=style&index=0&id=dd57bf94&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd57bf94"]])

export default __exports__